import { useNewTranslation } from 'hooks'
import _ from 'lodash'
import Dropdown from 'particles/Dropdown'
import MenuItem from 'particles/MenuItem'
import { EmptySearchResult } from 'particles/MenuItem/Search'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createGetRequestsAreLoading } from 'state'
import { getAmbassadorBrands, selectAmbassadorBrands } from 'state/ambassadors'
import { selectTeamFilter } from 'state/filter'
import { STATE_KEYS } from 'state/requests'

interface BrandFilterProps {
    disabled?: boolean
    selectedBrands: string[]
    setSelectedBrands: React.Dispatch<React.SetStateAction<string[]>>
}

const BrandFilter = ({ disabled, selectedBrands, setSelectedBrands }: BrandFilterProps) => {
    const brandsList = useSelector(selectAmbassadorBrands)
    const isLoading = useSelector(createGetRequestsAreLoading([STATE_KEYS.BrandsList]))
    const teamFilter = useSelector(selectTeamFilter)
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const [searchKeyword, setSearchKeyword] = useState('')
    const mounted = useRef(false)

    useEffect(() => {
        mounted.current = true
    }, [brandsList])

    useEffect(() => {
        return () => {
            mounted.current = false
        }
    }, [])

    const handleSearch = _.debounce((value: string) => {
        setSearchKeyword(value)
        dispatch(
            getAmbassadorBrands({
                name: value,
                team_uuid: teamFilter || undefined,
            }),
        )
    }, 500)

    const brandOptions = useMemo(() => {
        return brandsList.map(brand => {
            return {
                value: brand.uuid,
                label: `${brand.name} (${brand.country})`,
                secondInfo: brand.team_name ? brand.team_name : undefined,
            }
        })
    }, [brandsList, isLoading])

    return (
        <div>
            <Dropdown
                label={t('radioButton.manageTeams.companyType.brand')}
                placeholder={t('placeholderText.enterBrandName')}
                width={360}
                multiple
                hasChips={false}
                onChange={value => {
                    setSelectedBrands(value as string[])
                }}
                value={selectedBrands}
                isDisabled={disabled || (brandsList.length === 0 && !searchKeyword)}
                dataTestId="ambassador-brand-dropdown"
            >
                <MenuItem.Search
                    onSearch={handleSearch}
                    onClearSearch={() => {
                        setSelectedBrands([])
                        setSearchKeyword('')
                    }}
                    placeholder={t('placeholderText.enterCampaignBrandName')}
                />
                {brandOptions.length > 0 ? (
                    brandOptions.map((item, index: number) => (
                        <MenuItem.Checkbox
                            key={`menu-item-${index}`}
                            tabIndex={index}
                            text={item.secondInfo ? item.label + ' | ' + item.secondInfo : item.label}
                            value={item.value}
                        />
                    ))
                ) : (
                    <EmptySearchResult />
                )}
            </Dropdown>
        </div>
    )
}

export default BrandFilter
